var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgAud = function SvgAud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM9.633 19.897h1.788l-2.74-7.891H6.74L4 19.897h1.657l.607-1.881h2.773l.596 1.881zm4.801-7.892h-1.652v5.168c0 1.75 1.285 2.926 3.303 2.926 2.023 0 3.309-1.176 3.309-2.926v-5.168h-1.652v4.998c0 .995-.596 1.63-1.657 1.63-1.055 0-1.652-.634-1.652-1.63v-4.998zM21.32 12v7.897h3.106c2.363 0 3.702-1.438 3.702-4.003 0-2.472-1.356-3.894-3.702-3.894H21.32zm1.651 1.411v5.075h1.192c1.46 0 2.28-.897 2.28-2.565 0-1.597-.848-2.51-2.28-2.51h-1.192zm-15.362.235l-.99 3.095h2.067l-.979-3.095h-.098z"
  })));
};

export default SvgAud;